import { useState, useEffect } from "react";
import { inject, observer } from "mobx-react";

import { Card } from "primereact/card";
import { Sidebar } from "primereact/sidebar";

import RadioButtonUI from "@UI/RadioButtonUI";
import InputUI from "@UI/InputUI";
import CheckboxUI from "@UI/CheckboxUI";

import { changeValByPath } from "@utils";

import DefaultCard from "../../DefaultCard";
import { nanoid } from "nanoid";

import "./style.scss";
import { confirmDialog } from "primereact/confirmdialog";
import ButtonUI from "@UI/ButtonUI";

const QuestionSidebar = inject("mainStore")(
    observer(({ mainStore, questionModel, questions, stateQuestions, setStateQuestions, setQuestions, open, setOpen, changeableData, prePath, chartData }) => {
        //костыль для подсчета вложенностей в связях вопросов
        const [refresh, setRefresh] = useState(false);
        useEffect(() => {
            if (questions.length && chartData.length) {
                addLvlToQuestions(chartData, questions);
                setRefresh(!refresh);
            }
        }, [chartData, questions]);
        //костыль для подсчета вложенностей в связях вопросов

        const setState = (path, value) => {
            const updated = changeValByPath(path, value, questions);
            setQuestions(updated);
        };

        const updateMultipleFields = (index, newFields, question) => {
            const opt = question.options || [];
            let updated = changeValByPath(`${index}`, { ...questions[index], ...newFields }, questions);
            opt.forEach((el) => {
                if (el.relaitedId) updated = delAllChildren(el.relaitedId, updated);
            });

            setQuestions(updated);
        };

        const updateQuestionField = (index, key, value) => setState(`${index}.${key}`, value);
        const updateOptionField = (qIdx, optIdx, key, value) => setState(`${qIdx}.options.${optIdx}.${key}`, value);
        const handleAddQuestion = (_id = "") => setQuestions((prev) => [...prev, { ...questionModel, _id: _id || nanoid(), lvl: questions.length + 1 }]);

        const handleRemoveQuestion = (question) => {
            const updated = [...questions];
            question.options.forEach((i) => {
                if (i.relaitedId) questions.filter((f) => f._id !== i.relaitedId);
            });
            const deletedPerent = updated.filter((f) => f._id !== question._id);

            setQuestions(deletedPerent);
        };

        const handleBindQuestion = (qIdx, optIdx) => {
            const _id = nanoid();
            updateOptionField(qIdx, optIdx, "relaitedId", _id);
            handleAddQuestion(_id);
        };

        const handleAddOption = (qIdx) => {
            const newOpt = { text: "", isLimit: false, isLimitText: "", isLimitButtonText: "", relaitedId: null };
            setState(`${qIdx}.options`, [...questions[qIdx].options, newOpt]);
        };

        const handleRemoveOption = (qIdx, optIdx, option, isBindBtn) => {
            let newArr = isBindBtn
                ? changeValByPath(`${qIdx}.options.${optIdx}.relaitedId`, null, questions)
                : changeValByPath(
                      `${qIdx}.options`,
                      questions[qIdx].options.filter((_, i) => i !== optIdx),
                      questions,
                  );

            if (option.relaitedId) {
                newArr = delAllChildren(option.relaitedId, newArr);
            }

            setQuestions(newArr);
        };

        const delAllChildren = (relaitedId, newArr) => {
            const opt = newArr.find((f) => f._id == relaitedId);
            if (opt) newArr.forEach((el) => delAllChildren(el.relaitedId, newArr));
            return newArr.filter((f) => f._id !== relaitedId);
        };

        const handleSave = async () => {
            setOpen(false);

            if (changeableData.surveyId) {
                const req = await mainStore.putByUrl(`/abtest/surveys/${changeableData.surveyId}`, { questionsArray: questions });
                if (req && req.data) {
                    setQuestions(req.data?.questionsArray);
                    setStateQuestions(req.data?.questionsArray);
                }

                return;
            }
            const req = await mainStore.postByUrl("/abtest/surveys", { questionsArray: questions });

            if (req.data) {
                if (prePath.length > 0) {
                    let currentData = { ...changeableData };
                    currentData = changeValByPath(prePath.concat("surveyId").join("."), req.data._id, currentData);
                    mainStore.setMainStore("detailData", currentData);
                    return;
                }

                mainStore.setMainStore("detailData.surveyId", req.data._id);
                setQuestions(req.data?.questionsArray);
                setStateQuestions(req.data?.questionsArray);
            }
        };

        const confirm = () => {
            confirmDialog({
                message: "Ваши изменения не были сохранены",
                header: "Сохранить изменения?",
                icon: "pi pi-exclamation-triangle",
                defaultFocus: "accept",
                rejectLabel: "Не сохранять",
                acceptLabel: "Сохранить",
                rejectClassName: "p-button-danger",
                accept: () => handleSave(),
                reject: () => {
                    setOpen(false);
                    setQuestions(stateQuestions);
                },
            });
        };

        const isFormValid = () => {
            return questions.every((q) => {
                if (q.type === "question") {
                    if (!q.question?.trim()) return false;
                    if (!q.options?.length) return false;

                    return q.options.every((opt) => {
                        if (!opt.text?.trim()) return false;
                        if (opt.isLimit) {
                            if (!opt.isLimitText?.trim() || !opt.isLimitButtonText?.trim()) return false;
                        }
                        return true;
                    });
                }

                if (q.type === "geo") {
                    const opt = q.options?.[0];
                    if (!opt) return false;

                    return !!opt.isLimitText?.trim() && !!opt.isLimitButtonText?.trim();
                }

                return true;
            });
        };

        const diffData = JSON.stringify(questions) === JSON.stringify(stateQuestions);

        return (
            <Sidebar className="question-sidebar" visible={open} position="right" onHide={() => (!diffData ? confirm() : setOpen(false))}>
                <Card className="question-sidebar__card" title="Тип вопроса">
                    {questions.map((q, qIdx) => (
                        <QuestionBlock
                            key={qIdx}
                            idx={qIdx}
                            question={q}
                            onChange={updateQuestionField}
                            onRemove={handleRemoveQuestion}
                            onOptionChange={updateOptionField}
                            onOptionAdd={handleAddOption}
                            onOptionRemove={handleRemoveOption}
                            onBind={handleBindQuestion}
                            onRemoveBind={handleRemoveOption}
                            onUpdateMulti={updateMultipleFields}
                            changeableData={changeableData}
                        />
                    ))}
                    <ButtonUI onClick={() => handleAddQuestion()} className="questions__btn" label="Добавить последовательный вопрос" outlined icon="pi pi-plus-circle" />
                    <ButtonUI onClick={handleSave} label="Сохранить" severity="success" disabled={!isFormValid()} />
                </Card>
            </Sidebar>
        );
    }),
);

export default QuestionSidebar;
``;

const QuestionBlock = ({ idx, question, onChange, onRemove, onOptionChange, onOptionAdd, onOptionRemove, onBind, onRemoveBind, onUpdateMulti, changeableData }) => (
    <div className="question-sidebar__question" key={idx} id={question._id}>
        <div className="question-sidebar__row">
            <span>
                {question?.lvl2?.length > 1 ? "Связанный вопрос" : "Вопрос"} {question.lvl2}*
            </span>
            <RadioButtonUI
                radioData={radioData}
                value={question.type}
                onChange={(e) =>
                    onUpdateMulti(
                        idx,
                        {
                            question: "",
                            type: e.value,
                            options:
                                e.value === "geo"
                                    ? []
                                    : [
                                          { text: "", isLimit: false, isLimitText: "", isLimitButtonText: "", relaitedId: null },
                                          { text: "", isLimit: false, isLimitText: "", isLimitButtonText: "", relaitedId: null },
                                      ],
                            typeQuestions: e.value === "geo" ? "region" : "buttons",
                        },
                        question,
                    )
                }
            />
            <i className="pi pi-trash" onClick={() => onRemove(question)} />
        </div>
        <RadioButtonUI radioData={question.type === "geo" ? radioGeo : radioTypeQuestions} value={question.typeQuestions} onChange={(e) => onChange(idx, "typeQuestions", e.value)} />

        {question.type === "question" ? (
            <>
                <span className="question-sidebar__title">Доступ к предложению</span>
                <span className="question-sidebar__text">Поля вопроса</span>

                <InputUI label={`Формулировка вопроса ${question.lvl2}`} required placeholder="Введите вопрос" value={question.question} onChange={(e) => onChange(idx, "question", e.target.value)} />

                <div className="question-sidebar__options">
                    {question.options.map((opt, optIdx) => (
                        <OptionBlock key={optIdx} qIdx={idx} optIdx={optIdx} option={opt} onChange={onOptionChange} onRemove={onOptionRemove} onBind={onBind} onRemoveBind={onRemoveBind} />
                    ))}
                </div>

                <ButtonUI label="Добавить вариант" className="questions__btn" icon="pi pi-plus-circle" outlined onClick={() => onOptionAdd(idx)} />
            </>
        ) : (
            <div className="question-sidebar__row">
                <InputUI value={question?.options[0]?.isLimitText || ""} label="Текст сообщения об ограничении" required placeholder="Введите текст" onChange={(e) => onOptionChange(idx, 0, "isLimitText", e.target.value)} />
                <InputUI value={question?.options[0]?.isLimitButtonText || ""} label="Текст на кнопке под ограничением" required placeholder="Введите текст" onChange={(e) => onOptionChange(idx, 0, "isLimitButtonText", e.target.value)} />
            </div>
        )}

        <DefaultCard item={question} changeableData={changeableData} />
    </div>
);

const OptionBlock = ({ qIdx, optIdx, option, onChange, onRemove, onBind, onRemoveBind }) => (
    <div className="question-sidebar__option">
        <InputUI label={`Вариант ${optIdx + 1}`} required placeholder="Введите вариант" value={option.text} onChange={(e) => onChange(qIdx, optIdx, "text", e.target.value)} />
        {option.isLimit ? (
            <>
                <InputUI value={option.isLimitText} label="Текст сообщения об ограничении" required placeholder="Введите текст" onChange={(e) => onChange(qIdx, optIdx, "isLimitText", e.target.value)} />
                <InputUI value={option.isLimitButtonText} label="Текст на кнопке под ограничением" required placeholder="Введите текст" onChange={(e) => onChange(qIdx, optIdx, "isLimitButtonText", e.target.value)} />
            </>
        ) : null}

        <div className="question-sidebar__row">
            <CheckboxUI label="Ограничения" required value={option.isLimit} onChange={(e) => onChange(qIdx, optIdx, "isLimit", e.checked)} />
            {option.relaitedId ? (
                <ButtonUI icon="pi pi-check" label="Связанный вопрос" onClick={() => onRemoveBind(qIdx, optIdx, option, true)} />
            ) : (
                <ButtonUI icon="pi pi-plus-circle" label="Связанный вопрос" outlined className="question-sidebar__bind" onClick={() => onBind(qIdx, optIdx)} />
            )}
        </div>

        <i className="pi pi-trash" onClick={() => onRemove(qIdx, optIdx, option)} />
    </div>
);

const addLvlToQuestions = (chartData, questions) => {
    const idToPathMap = {};
    const traverseNode = (node, currentPath, map) => {
        if (node._id && !map[node._id]) map[node._id] = currentPath.filter((_, idx) => idx <= 1 || idx % 2 !== 0).join(".");
        if (node.children && node.children.length > 0) {
            node.children
                .filter((f) => f.children)
                .forEach((child, index) => {
                    const newPath = [...currentPath, index + 1];
                    traverseNode(child, newPath, map);
                });
        }
    };

    chartData.forEach((tree, treeIndex) => {
        const rootNode = tree[0];
        traverseNode(rootNode, [treeIndex + 1], idToPathMap);
    });

    questions.forEach((question) => {
        if (idToPathMap[question._id]) question.lvl2 = idToPathMap[question._id];
    });
};

const radioData = [
    { label: "Опции настройки вопроса", value: "question" },
    { label: "Наследование ГЕО", value: "geo" },
];

const radioTypeQuestions = [
    { label: "Группа кнопок", value: "buttons" },
    { label: "Радио-кнопки (Единичный выбор)", value: "radioButtons" },
    { label: "Выпадающий список", value: "selectSuggest" },
    { label: "Чеклист (Множественный выбор)", value: "checkbox" },
];

const radioGeo = [
    { label: "Регион", value: "region" },
    { label: "Город", value: "city" },
    { label: "Станция метро", value: "metro" },
];
